export const siteDate = "2026-09-09";

export const tickerLines: string[] = [
  "首曝｜S姓男星深夜同框神秘经纪人，偶遇照两分钟后被全平台清理",
  "独家｜选秀C位被曝两年内三度换约，违约金条款疑似高达七位数",
  "速报｜当红女团新专封面被扒“撞车”前作，工作室暂未回应",
  "进展｜直播间“假一赔十”翻车事件，品牌方今日发出第三轮声明",
  "社会现场｜网红医美机构再被点名，涉事医生执业记录疑被清零重开",
  "财经｜多家MCN密集注册新主体，被指正为“拆号”悄悄做准备",
  "科技速报｜新机上架首日渠道破价，线上线下价差最高超千元",
  "圈内｜古装剧组被曝停拍三日，副导演凌晨发文配图“都冷静点”",
];

export const topStory = {
  kicker: "今日头版 · 突发追踪",
  title:
    "顶流男团“深夜解散”传闻发酵：官方只回四个字，粉丝群一夜两度改名",
  lead:
    "从凌晨话题空降热搜第一，到工作室两小时后仅回复“勿信传闻”，再到粉丝官群连夜改名分家——这轮突发爆料不到六小时已三连反转。抢先版时间线正在滚动更新，从事件苗头到最新内幕一步到位。",
  meta: ["#圈内 #独家深挖", "进行中 · 已更新 5 轮", "今日 07:20 起"],
};

export const stationStats: Array<{ label: string; value: string; tone: string }> = [
  { label: "今日已更快讯", value: "128", tone: "primary" },
  { label: "正在追踪话题", value: "41", tone: "accent" },
  { label: "抢先版内幕", value: "16", tone: "secondary" },
  { label: "实时信源监测", value: "9", tone: "foreground" },
];

export const stationFlash: Array<{
  time: string;
  title: string;
  tone: string;
}> = [
  { time: "09:42", title: "S姓男星同框照清理后，账号异地登录提示流出", tone: "primary" },
  { time: "09:21", title: "选秀C位旧经纪公司发“八字”声明：好聚好散", tone: "accent" },
  { time: "08:58", title: "女团新专封面对比图被做进长图，转发已过万", tone: "secondary" },
  { time: "08:36", title: "医美机构挂号页短暂下线，客服改口称“系统维护”", tone: "secondary" },
];

export const dockEntries: Array<{
  key: string;
  name: string;
  alias: string;
  icon: string;
  today: string;
  state: string;
  tone: "primary" | "accent" | "secondary" | "foreground";
}> = [
  {
    key: "ent",
    name: "圈内 · 台前幕后",
    alias: "艺人动态 / 剧组片约",
    icon: "ri-user-star-line",
    today: "+37",
    state: "实时追踪中",
    tone: "primary",
  },
  {
    key: "fin",
    name: "财经 · 资本商战",
    alias: "公司拆号 / 违约金",
    icon: "ri-bank-card-line",
    today: "+19",
    state: "信源监测中",
    tone: "secondary",
  },
  {
    key: "soc",
    name: "社会 · 现场直击",
    alias: "机构资质 / 维权事件",
    icon: "ri-focus-3-line",
    today: "+24",
    state: "现场核对中",
    tone: "accent",
  },
  {
    key: "tech",
    name: "科技 · 数码前线",
    alias: "新品破价 / 渠道爆料",
    icon: "ri-computer-line",
    today: "+16",
    state: "行情追踪中",
    tone: "secondary",
  },
  {
    key: "game",
    name: "竞技 · 场内外事",
    alias: "转会签约 / 假赛传闻",
    icon: "ri-trophy-line",
    today: "+11",
    state: "持续跟线中",
    tone: "foreground",
  },
  {
    key: "live",
    name: "红人 · 网红直播",
    alias: "停播 / 退订 / 拆伙",
    icon: "ri-live-line",
    today: "+21",
    state: "实时追踪中",
    tone: "primary",
  },
];

export const feedItems: Array<{
  id: number;
  time: string;
  kind: string;
  tag: string;
  tone: "primary" | "accent" | "secondary" | "foreground";
  pinned?: boolean;
  title: string;
  lead: string;
}> = [
  {
    id: 1,
    time: "09:42",
    kind: "首曝",
    tag: "圈内",
    tone: "primary",
    pinned: true,
    title: "S姓男星深夜同框神秘经纪人，机场偶遇照两分钟后被全平台清理",
    lead:
      "爆料人提供的两张原图已被第三方存证，显示拍摄于昨晚十一点半左右；截图上的时间水印与删帖记录吻合，事件进入核实阶段。",
  },
  {
    id: 2,
    time: "09:21",
    kind: "独家",
    tag: "圈内",
    tone: "primary",
    title: "选秀C位被曝两年内三度换约，违约金条款疑似高达七位数",
    lead:
      "从三家合作方的红头文件里拼出的时间线显示，该艺人合约更迭频繁；多名知情人指其中一份含“天价解约金”附加条款。",
  },
  {
    id: 3,
    time: "08:58",
    kind: "速报",
    tag: "科技",
    tone: "secondary",
    title: "新旗舰发布 12 小时即被扒“首日破价”，渠道价差最高超千元",
    lead:
      "线上多个店铺用优惠券叠加后价格低于官方首发，黄牛报价同步走低；客服口径前后不一，尚未见官方限价表态。",
  },
  {
    id: 4,
    time: "08:36",
    kind: "进展",
    tag: "财经",
    tone: "secondary",
    title: "连锁茶饮“代运营暴雷”门店名单再扩三家，总部称已介入调查",
    lead:
      "新增三家门店位于不同省份，涉事加盟商陆续晒出合同与打款记录；总部最新声明承诺本周内给出统一处理方案。",
  },
  {
    id: 5,
    time: "08:12",
    kind: "首曝",
    tag: "社会",
    tone: "accent",
    title: "某医美连锁被曝“资质挂靠”，涉事医生执业记录疑被清零重开",
    lead:
      "卫健委公示页与门店公示栏信息存在出入，执业地点多次变更；多名前顾客反映术前面诊医生与手术医生并非同一人。",
  },
  {
    id: 6,
    time: "07:49",
    kind: "独家",
    tag: "圈内",
    tone: "primary",
    title: "顶流小生后援会凌晨清空认证微博，粉丝站连夜发布解散声明",
    lead:
      "后援会大号改名并清空内容，散粉大群同步解散重组；被指与“换签新公司”传闻互为佐证，工作室仍未置评。",
  },
  {
    id: 7,
    time: "07:20",
    kind: "速报",
    tag: "红人",
    tone: "primary",
    title: "千万粉大主播官宣“停播半月”，评论区涌入大量退预付款截图",
    lead:
      "停播公告只给时间段未给理由，弹幕与评论同时出现“货未发”“款未退”的截图；客服入口排队人数一度过千。",
  },
  {
    id: 8,
    time: "06:55",
    kind: "进展",
    tag: "财经",
    tone: "secondary",
    title: "多家 MCN 被曝“拆号”新主体，头部主播公司密集变更法人",
    lead:
      "工商信息显示一周内新增十余个相近名称的新主体，法定代表人多有交叉；业内人士指或与近期账号归属权纠纷有关。",
  },
  {
    id: 9,
    time: "06:18",
    kind: "独家",
    tag: "科技",
    tone: "secondary",
    title: "新机渠道价差被扒破千元，黄牛自称首发价或跌破发行价",
    lead:
      "第三方比价页面被贴出多档报价，旗舰机型领券后到手价低于官方千余元；渠道商称“货压得越久降得越快”。",
  },
  {
    id: 10,
    time: "05:52",
    kind: "速报",
    tag: "圈内",
    tone: "primary",
    title: "古装剧组被曝停拍三日，副导演凌晨发动态配文“都冷静点”",
    lead:
      "场务微博秒删的探班照显示片场布景被部分拆除；制片方群发通知称“档期顺延”，主演通告表暂未更新。",
  },
];

export const hotRank: Array<{
  title: string;
  heat: number;
  trend: string;
  up?: boolean;
}> = [
  { title: "顶流男团“解散”疑云", heat: 98, trend: "首曝", up: true },
  { title: "S姓男星同框风波", heat: 93, trend: "新", up: true },
  { title: "某医美机构资质质疑", heat: 87, trend: "热议", up: true },
  { title: "综艺“天价违约金”条款", heat: 82, trend: "独家", up: true },
  { title: "连锁茶饮代运营暴雷", heat: 76, trend: "进展", up: false },
  { title: "大主播停播与退订潮", heat: 71, trend: "升温", up: true },
  { title: "顶流小生换签新公司", heat: 66, trend: "待证", up: false },
  { title: "古装剧组停拍风波", heat: 60, trend: "回落", up: false },
];

export const zoneArchive: Array<{
  key: string;
  label: string;
  icon: string;
  items: Array<{ time: string; tag: string; title: string }>;
}> = [
  {
    key: "ent",
    label: "圈内 · 台前幕后",
    icon: "ri-user-star-line",
    items: [
      { time: "09:21", tag: "独家", title: "选秀C位三度换约，旧公司回“好聚好散”" },
      { time: "08:12", tag: "进展", title: "顶流小生后援会清空微博，粉丝站发解散声明" },
      { time: "07:20", tag: "首曝", title: "顶流男团“解散”传闻，官方只回四个字" },
      { time: "05:52", tag: "速报", title: "古装剧组停拍三日，副导演凌晨发文" },
    ],
  },
  {
    key: "fin",
    label: "财经 · 资本商战",
    icon: "ri-bank-card-line",
    items: [
      { time: "08:36", tag: "进展", title: "茶饮代运营暴雷门店再扩，总部称已介入" },
      { time: "06:55", tag: "独家", title: "MCN 被曝“拆号”，新主体一周新增十余家" },
      { time: "昨 22:10", tag: "首曝", title: "头部主播公司密集变更法人，疑为拆分铺路" },
    ],
  },
  {
    key: "soc",
    label: "社会 · 现场直击",
    icon: "ri-focus-3-line",
    items: [
      { time: "08:58", tag: "首曝", title: "医美机构被曝资质挂靠，涉事医生记录清零" },
      { time: "昨 21:40", tag: "速报", title: "机构挂号页短暂下线，客服改口称维护" },
      { time: "昨 19:05", tag: "进展", title: "前顾客接龙补充病历，数量已超四十人" },
    ],
  },
  {
    key: "tech",
    label: "科技 · 数码前线",
    icon: "ri-computer-line",
    items: [
      { time: "09:05", tag: "速报", title: "新旗舰首日破价，券后价低于官方千余元" },
      { time: "06:18", tag: "独家", title: "渠道价差被扒破千元，黄牛称会再降" },
      { time: "昨 20:30", tag: "进展", title: "官方客服口径不一，尚未见限价表态" },
    ],
  },
];

export const deepArchive: Array<{
  no: string;
  title: string;
  teaser: string;
  rounds: string;
  status: "深挖中" | "已闭环";
  progress: number;
  tone: "primary" | "accent" | "secondary" | "foreground";
}> = [
  {
    no: "深挖 01",
    title: "顶流男团“解散”疑云全记录",
    teaser:
      "从三小时内的三次反转入手，逐条比对事件时间线、工作室声明措辞与粉丝站动作，做了一份标注式拆解。",
    rounds: "第 5 轮更新",
    status: "深挖中",
    progress: 78,
    tone: "primary",
  },
  {
    no: "深挖 02",
    title: "S姓男星同框图源考证",
    teaser:
      "两张原图的拍摄地、时间水印与删除路径逐一核查，先还原“为何秒删”，再谈背后可能的合约风险。",
    rounds: "第 2 轮更新",
    status: "深挖中",
    progress: 46,
    tone: "accent",
  },
  {
    no: "深挖 03",
    title: "MCN“拆号”图谱：同一法人名下 11 个新主体",
    teaser:
      "把工商变更、主播归属与近期纠纷交叉排列，画出头部公司“分身”路径，财经与红人两条线合并成图。",
    rounds: "第 3 轮更新",
    status: "已闭环",
    progress: 92,
    tone: "secondary",
  },
  {
    no: "深挖 04",
    title: "综艺“天价违约金”条款逐字解读",
    teaser:
      "把网传红头条款逐字拆开，从法律视角标注风险点，解释为何艺人方会“连夜改口、对外只谈好聚好散”。",
    rounds: "第 1 轮更新",
    status: "深挖中",
    progress: 30,
    tone: "foreground",
  },
];

export const accessEntries: Array<{
  icon: string;
  title: string;
  desc: string;
  action: string;
  tone: "primary" | "accent" | "secondary" | "foreground";
}> = [
  {
    icon: "ri-smartphone-line",
    title: "抢先版客户端",
    desc: "低频打扰，只把真正够猛的第一现场推到你手机。",
    action: "下载抢先版",
    tone: "primary",
  },
  {
    icon: "ri-notification-3-line",
    title: "突发即推订阅",
    desc: "从事件苗头到完整内幕不设缓冲，响了就点开看。",
    action: "开启即时推送",
    tone: "accent",
  },
  {
    icon: "ri-folder-open-line",
    title: "深挖档案库",
    desc: "连载式内幕进度一目了然，想看哪条先占个座。",
    action: "进入档案库",
    tone: "secondary",
  },
];

export const navLinks: Array<{ href: string; label: string }> = [
  { href: "#station", label: "今日站台" },
  { href: "#dock", label: "追踪入口" },
  { href: "#feed", label: "快讯流" },
  { href: "#rank", label: "热议榜" },
  { href: "#zones", label: "分区档案" },
  { href: "#deep", label: "深挖抢先版" },
];